exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label {\r\n\tfont-size: 10pt;\r\n\tfont-weight: normal;\r\n\tcolor: #444;\r\n} \r\n\r\n.ui-autocomplete-multiple-container {\r\n\twidth: 100%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/detail-assenza-malattia/detail-assenza-malattia.component.css
// module id = 330
// module chunks = 0